import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FilterUiService } from 'src/app/services/filter-ui.service';
import { ForecastingService } from 'src/app/services/forecasting.service';

@Component({
  selector: 'app-forecasting-woodenstreet-organism',
  templateUrl: './forecasting-woodenstreet-organism.component.html',
  styleUrls: ['./forecasting-woodenstreet-organism.component.scss'],
  providers: [DatePipe]
})
export class ForecastingWoodenstreetOrganismComponent implements OnInit {
  listScenarios: any;
  formData;
  updateData: boolean = false;
  categoryL1: any;
  activeIndex: any = 0;
  renderScenario = true;
  fieldData: any;
  headerData: any;
  visiblePOPUP: boolean;

  constructor(private forecasting: ForecastingService, private filterService: FilterUiService, private datePipe: DatePipe) { }
  ngOnInit(): void {
    this.filterService.getFilters(['FG', 'TRADED']).subscribe(res => {
      this.categoryL1 = res['filterDataList']?.find(i => i.code === 'categoryL1')?.values;
    })
    this.forecasting.getListScenarios().subscribe((res: Array<any>) => {
      this.listScenarios = res.reverse().filter(scenario => scenario.status == null || scenario.status != 'Deleted');
      const activeScenario: any = this.listScenarios?.find((scenario: any) => scenario.active === true);
      // this.formData = activeScenario || null;
      if (activeScenario) {
        this.listScenarios = [
          activeScenario,
          ...this.listScenarios.filter((scenario: any) => scenario !== activeScenario),
        ];
      }
      this.activeIndex = activeScenario ? this.listScenarios.indexOf(activeScenario) : 0;
      this.formData = this.listScenarios.length > 0 ? this.listScenarios[this.activeIndex] : null;
      this.reloadScenario();
    });
  }
  reloadScenario() {
    this.renderScenario = false;
    setTimeout(() => this.renderScenario = true, 0);
  }
  createNewScenario(): void {
    this.formData = null;
    this.reloadScenario()
  }
  onScenarioUpdated(code: any): void {
    this.forecasting.getListScenarios().subscribe((res: Array<any>) => {
      this.listScenarios = res.reverse().filter(scenario => scenario.status == null || scenario.status != 'Deleted');
      const activeScenario: any = this.listScenarios.find(scenario => scenario.code === code);
      this.activeIndex = activeScenario ? this.listScenarios.indexOf(activeScenario) : 0;
    });
  }

  handleItemClick(item: any, index: any) {
    this.activeIndex = index;
    this.formData = item;
    this.reloadScenario()
  }

  getMessage(item: any) {
    return `Demand conversion has happened on ${this.datePipe.transform(item.demandConversionDate, 'MMMM d, yyyy')}`;
  }

  handlePOPUP(event: any) {
    this.fieldData = event.fieldData;
    this.headerData = event.header;
    this.visiblePOPUP = true;
  }
}
